import * as React from "react"
import * as AvatarPrimitive from "@radix-ui/react-avatar"
import { cn } from "@/lib/utils"

// Since we might not have @radix-ui/react-avatar installed, I will implement a simple version
// If the user has it, I'd use it. But I didn't see it in package.json (only slot).
// Note: package.json only had @radix-ui/react-slot.
// So I will implement custom Avatar without Radix to avoid install errors/unauthorized installs.

const Avatar = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
    <div data-component-id="src/components/ui/avatar.tsx:14:4" data-component-path="src/components/ui/avatar.tsx" data-component-line="14" data-component-end-line="21" data-component-file="avatar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
        ref={ref}
        className={cn(
            "relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full",
            className
        )}
        {...props}
    />
))
Avatar.displayName = "Avatar"

const AvatarImage = React.forwardRef<
    HTMLImageElement,
    React.ImgHTMLAttributes<HTMLImageElement>
>(({ className, ...props }, ref) => (
    <img data-component-id="src/components/ui/avatar.tsx:29:4" data-component-path="src/components/ui/avatar.tsx" data-component-line="29" data-component-end-line="33" data-component-file="avatar.tsx" data-component-name="img" data-component-content="%7B%22elementName%22%3A%22img%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
        ref={ref}
        className={cn("aspect-square h-full w-full", className)}
        {...props}
    />
))
AvatarImage.displayName = "AvatarImage"

const AvatarFallback = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
    <div data-component-id="src/components/ui/avatar.tsx:41:4" data-component-path="src/components/ui/avatar.tsx" data-component-line="41" data-component-end-line="48" data-component-file="avatar.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
        ref={ref}
        className={cn(
            "flex h-full w-full items-center justify-center rounded-full bg-muted",
            className
        )}
        {...props}
    />
))
AvatarFallback.displayName = "AvatarFallback"

export { Avatar, AvatarImage, AvatarFallback }
